module.exports = __webpack_public_path__ + "img/title.b7ae3f83.png";